// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1giLZ","header":"PatientBlock_header__1ySHZ","label":"PatientBlock_label__jR_Fj","option":"PatientBlock_option__3i9s7"};